export function formatRating(rating) {
  return rating.toFixed(1).replace(".", ",");
}
